import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './Typography.module.css.mjs';
import { typographySizeClasses } from './Typography.utils.mjs';

const Typography = polymorphicFactory(
  (props, ref) => {
    const { size = "paragraph-medium", inherit, className, component, children, ...rest } = props;
    const classNames = clsx(
      classes.root,
      className,
      size && typographySizeClasses[size],
      `dsm-typography-${typeof component === "string" ? component : "p"}-${size}${rest.mod ? `-${rest.mod}` : ""}`
    );
    return /* @__PURE__ */ React.createElement(Box, { className: classNames, component: component || "p", ref, ...rest, ...{ "data-inherit": inherit || void 0 } }, children);
  }
);

export { Typography };
